import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon, TrainIcon, TreesIcon, ShieldCheckIcon, CarIcon, BuildingIcon } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <LeafIcon className="w-8 h-8" data-id="element-74" />,
    title: 'Ekologické bydlení',
    description: 'Moderní technologie šetrné k životnímu prostředí, zelené střechy a úsporné systémy.'
  }, {
    icon: <TrainIcon className="w-8 h-8" data-id="element-75" />,
    title: 'Skvělá dopravní dostupnost',
    description: 'Přímé spojení s centrem Prahy, blízkost dálnice D1 a autobusové linky.'
  }, {
    icon: <TreesIcon className="w-8 h-8" data-id="element-76" />,
    title: 'Krásné prostředí',
    description: 'Obklopeno zelení s výhledy do okolní krajiny a klidným předměstským životem.'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8" data-id="element-77" />,
    title: 'Moderní technologie',
    description: 'Chytré řešení vytápění, ventilace a zabezpečení pro maximální komfort.'
  }, {
    icon: <CarIcon className="w-8 h-8" data-id="element-78" />,
    title: 'Podzemní parkování',
    description: 'Dvě patra podzemních garáží s dostatkem parkovacích míst a sklepní prostory.'
  }, {
    icon: <BuildingIcon className="w-8 h-8" data-id="element-79" />,
    title: 'Komerční vybavenost',
    description: 'Obchody a služby přímo v areálu pro pohodlný každodenní život.'
  }];
  return <section id="vyhody" className="py-24 bg-base-cream" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-82">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-83">
            Proč Svatý Václav
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-84">
            Benefity, které dělají z tohoto projektu ideální místo pro život
          </p>
        </motion.div>

        {/* Image Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full h-64 md:h-96 rounded-2xl overflow-hidden mb-16 relative shadow-xl" data-id="element-85">
          <img src="https://cdn.magicpatterns.com/uploads/v6gs57YcUP7SjvabVV3GrM/17.png" alt="Výhled z balkonu" className="w-full h-full object-cover" data-id="element-86" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-87">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group border border-primary/5" data-id="element-88">
              <div className="w-16 h-16 bg-primary/5 text-primary rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300" data-id="element-89">
                {feature.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-base-dark mb-3" data-id="element-90">
                {feature.title}
              </h3>
              <p className="text-base-gray leading-relaxed" data-id="element-91">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}